module.exports = __webpack_public_path__ + "static/media/Dental.2026a28a.svg";